import { getProductionDataClientModeError } from '@/lib/data-client/mode'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Outlet } from '@tanstack/react-router'
import { Toaster } from 'sonner'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

export function RootLayout() {
  const productionModeError = getProductionDataClientModeError()
  if (productionModeError) {
    return (
      <div className="grid min-h-dvh place-items-center bg-slate-50 p-6">
        <div className="w-full max-w-lg rounded-lg border border-red-200 bg-white p-6 shadow-sm">
          <div className="inline-flex rounded-md bg-red-50 px-2 py-1 text-xs font-semibold text-red-700">
            {productionModeError.code}
          </div>
          <h1 className="mt-4 text-xl font-semibold text-slate-950">系統環境設定錯誤</h1>
          <p className="mt-3 text-sm leading-6 text-slate-600">{productionModeError.message}</p>
        </div>
      </div>
    )
  }

  return (
    <QueryClientProvider client={queryClient}>
      <Outlet />
      <Toaster richColors position="bottom-center" />
    </QueryClientProvider>
  )
}
